import React from 'react';
import SectionTitle from './SectionTitle';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { OTETSUTABI_LIST_ID, SECONDARY_COLOR } from '../constants';
import OtetsutabiListItem from './OtetsutabiListItem';
import Plans from './Plans';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: SECONDARY_COLOR,

    padding: theme.spacing(8, 2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(8, 4),
    },
  },
  inner: {
    maxWidth: theme.breakpoints.values.lg - 100,
    margin: 'auto',
  },
}));

const OtetsutabiList = ({ plans, onAirList, authenticated }) => {
  const classes = useStyles();
  return (
    <div className={classes.root} id={OTETSUTABI_LIST_ID}>
      <div className={classes.inner}>
        <SectionTitle
          title="OTETSUTABI LIST"
          subtitle="番組で紹介したおてつたび先"
        />
        {onAirList.map((data, index) => (
          <OtetsutabiListItem
            key={data.order}
            {...data}
            authenticated={authenticated}
            isLast={index === onAirList.length - 1}
          />
        ))}
        <Plans plans={plans} authenticated={authenticated} />
      </div>
    </div>
  );
};

export default OtetsutabiList;
